module.exports = __webpack_public_path__ + "media/crypto/mkr-c46ce75e.png";